//import app from '../App.vue'
import list from '../components/list.vue'
import userList from '../components/user/userList.vue'

const routes = [
  {path:'/login',component:() => import('../components/login.vue')},
  {
    path:'',component:() => import('../App.vue'),
    children:[
      {
        path:'/',
        component:list,
        meta:{type:1}
      },
      {
        path:'/list',
        component:() => import('../components/list.vue'),
        meta:{type:1}
      },
      {path:'/add',component:() => import('../components/create.vue')},
      {path:'/edit',component:() => import('../components/edit.vue')},
      {path:'/user',component:() => import('../components/user/userList.vue')},
      {path:'/userAdd',component:() => import('../components/user/userAdd.vue')},
      {path:'/modifyPwd',component:() => import('../components/user/modifyPwd.vue')},
      {
        path:'/search',
        component:() => import('../components/search.vue'),
        meta:{type:1}
      },
      {path:'/docList',component:() => import('../components/docAdmin')},
      {
        path:'/excelpreview',
        component:() => import('../components/excelpreview.vue'),
        meta:{type:1}
      },
    ]
  },
  {path:'/passport',component:() => import('../components/passport/passport.vue')}
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/router.js